import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Menus from "./app-menu";

// función para aplanar Menus en una lista de paths
const flattenMenus = (menus) => {
  const paths = [];
  const traverse = (items) => {
    items.forEach((item) => {
      // si el item tiene path y no empieza con "__"
      if (item.path && !item.path.startsWith("__")) {
        paths.push(item.path); // lo guardamos en la lista
      }

      // si tiene hijos, recorremos recursivamente
      if (item.children) {
        traverse(item.children);
      }
    });
  };

  traverse(menus); // empezamos recorriendo el array de Menus principal

  return paths; // devolvemos todos los paths encontrados
};

const allMenuPaths = flattenMenus(Menus);

const ProtectedRoute = ({ children }) => {
  const { roleMenus, isAdmin } = useAuth();
  const location = useLocation();

  // ruta actual
  const currentPath = location.pathname;

  // si es admin, puede entrar a todo
  if (isAdmin()) {
    return children;
  }

  // Verificamos si la ruta actual pertenece a algún menú definido
  const belongsToMenus = allMenuPaths.some((menuPath) =>
    currentPath.startsWith(menuPath)
  );

  if (belongsToMenus) {
    // Si pertenece a menús, validamos si el rol lo tiene permitido
    const isAllowed = roleMenus.some((menuPath) =>
      currentPath.startsWith(menuPath)
    );

    if (!isAllowed) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Si no pertenece a menús -> dejar pasar
  return children;
};

export default ProtectedRoute;
